angular.module('GlobalHelpersModule').filter "downcaseAndDash", ->
  (input) ->
    input = input or ""

    # downcase and replace spaces with dashes '-'
    # used to build data-element values for testing
    out = input.replace(/\s+/g, '-').toLowerCase() or ""
    return out